/**
 * `Ф2` / `Ф3` (кабинет): текст отказа сервера — как есть, без выдумки.
 *
 * Сервер возвращает причину в `error` (или `message`); если её нет, остаётся
 * общий текст. Показывать «что-то пошло не так» вместо названной причины —
 * значит скрыть от человека, что именно не принято.
 */
export function serverMessageOf(
  error: unknown,
  fallback = "Не удалось выполнить действие",
): string {
  const value = error as {
    response?: { data?: { error?: string; message?: string } };
    message?: string;
  };

  return (
    value?.response?.data?.error ||
    value?.response?.data?.message ||
    value?.message ||
    fallback
  );
}
